import request from '@/utils/request'

export function create (id, platform) {
  const method = 'post'
  const url = `/user/create`
  return request({
    url,
    method,
    data: {id, platform}
  })  
}

export function createProtocol (id, platform) {
  const method = 'post'
  const url = `/user/create_protocol`
  return request({
    url,
    method,
    data: {id, platform}
  })  
}

export function activate (id, platform) {
  const method = 'post'
  const url = `/user/activate`
  return request({
    url,
    method,
    data: {id, platform}
  })  
}

export function deactivate (id, platform) {
  const method = 'post'
  const url = `/user/deactivate`
  return request({
    url,
    method,
    data: {id, platform}
  })  
}

export function remove (id, platform) {
  const method = 'post'
  const url = `/user/remove`
  return request({
    url,
    method,
    data: {id, platform}
  })  
}

export function removeProtocol (id, platform) {
  const method = 'post'
  const url = `/user/remove_protocol`
  return request({
    url,
    method,
    data: {id, platform}
  })  
}

export function checkStatus (id) {
  const method = 'get'
  const url = `/checkPlatformsUserStatus/${id}`
  return request({
    url,
    method,
  })  
}


